const SocialEnum = Object.freeze({
    FACEBOOK: 'facebook',
    TWITTER: 'twitter',
    INSTAGRAM: 'instagram',
    SNAPCHAT: 'snapchat',
    PINTEREST: 'pinterest',
    WHATSAPP:'whatsapp',
    Linkedin: 'linkedin',
    Email: 'email',
    Copy: 'copy'
});

export default SocialEnum;
